import React from 'react';
import Table from 'react-bootstrap/Table'
import MetricFormatter from 'dashboards/MetricFormatter'
import PDFPage from 'pdfs/PDFPage'

class PPCPdfSummarySearch extends React.Component {
  constructor(props) {
    super(props);

    this.state = {};
  }

  getPageNumber(current) {
    return current + 1;
  }

  render() {
    let metrics = this.props.search_metrics;
    let pageNumber = 0;
    let clientsPerPage = 35;

    const clients = Object.keys(this.props.search_metrics);
    const firstKey = clients[0];
    const searchMetrics = Object.keys(this.props.search_metrics[firstKey]).filter((el) => !el.includes("yy"));

    let totals = {};

    clients.map((client) => {
      searchMetrics.map((metricName) => {
        let mValue = this.props.search_metrics[client][metricName];
        totals[metricName] ? (totals[metricName] += mValue) : (totals[metricName] = mValue);
      });
    });

    totals["rev_or_conv_yy"] = ((totals["rev_or_conv"] - totals["rev_or_conv_ly"]) / totals["rev_or_conv_ly"]) * 100;
    totals["rev_or_conv_lm_yy"] = ((totals["rev_or_conv_lm"] - totals["rev_or_conv_lmly"]) / totals["rev_or_conv_lmly"]) * 100;

    return (
      <div>
        {[...Array(Math.ceil(this.props.client_list.length / clientsPerPage))].map((x, index) => {
          return (
            <PDFPage pageNumber={(pageNumber = this.getPageNumber(pageNumber))} hideLogo={false}>
              <div className="pdf-header justify-content-center">
                <h1 className="text-white text-center">PPC Summary Search</h1>
                <h5 className="text-white text-center">{this.props.date_formatted}</h5>
              </div>
              <div className="mb-2">
                <Table className="mt-2 table-white table-striped metric-table">
                  <thead>
                    <tr>
                      <th>Client</th>
                      {this.props.metric_list.map((metric) => {
                        return <th key={metric.display_name}>{metric.display_name}</th>;
                      })}
                    </tr>
                  </thead>
                  <tbody>
                    {this.props.client_list.splice(0, 35).map((client) => {
                      return (
                        <tr key={client.client_name}>
                          <td className="client1" style={{ textAlign: "left", fontWeight: "900" }}>
                            {client.client_name}
                          </td>
                          {this.props.metric_list.map((metric) => {
                            let value = metrics[client.client_name][metric.programmatic_name];
                            let className = "";
                            let Formatter;

                            if (metric.programmatic_name == "budget") {
                              Formatter = MetricFormatter.Revenue;
                            } else if (metric.programmatic_name == "proj_to_budget") {
                              Formatter = MetricFormatter.Revenue;
                              className = value > 0 ? "bg-danger" : "bg-success";
                            } else if (metric.programmatic_name == "rev_or_conv") {
                              Formatter = client.account_type == "ecommerce" ? MetricFormatter.Revenue : MetricFormatter.Conversions;
                            } else if (metric.programmatic_name == "kpi_goal") {
                              Formatter = client.account_type == "ecommerce" ? MetricFormatter.ROAS : MetricFormatter.CPA;
                            } else if (metric.programmatic_name == "proj_to_kpi_goal") {
                              Formatter = client.account_type == "ecommerce" ? MetricFormatter.ROAS : MetricFormatter.CPA;
                              className =
                                client.account_type == "ecommerce" ? (value > 0 ? "bg-success" : "bg-danger") : value > 0 ? "bg-danger" : "bg-success";
                            }

                            if (metric.programmatic_name.includes("yy")) {
                              Formatter = MetricFormatter.YY;
                              className = value > 0 ? "bg-success" : "bg-danger";
                            }

                            return (
                              <td key={metric.programmatic_name} className={className ? className + " text-white" : ""}>
                                <Formatter value={value} />
                              </td>
                            );
                          })}
                        </tr>
                      );
                    })}
                    <tr>
                      <td className="client-cell" style={{ textAlign: "left", fontWeight: "900" }}>
                        TOTALS
                      </td>
                      {this.props.metric_list.map((metric) => {
                        let value = totals[metric.programmatic_name];
                        let prefix = "";
                        let suffix = "";
                        let precision = 0;
                        let commas = true;
                        let className = false;

                        let Formatter;

                        if (metric.programmatic_name == "budget") {
                          Formatter = MetricFormatter.Revenue;
                        } else if (metric.programmatic_name == "proj_to_budget") {
                          Formatter = MetricFormatter.Revenue;
                          className = value > 0 ? "bg-danger" : "bg-success";
                        } else if (metric.programmatic_name == "rev_or_conv") {
                          Formatter = MetricFormatter.Revenue;
                        } else if (metric.programmatic_name == "kpi_goal") {
                          Formatter = MetricFormatter.Revenue;
                        } else if (metric.programmatic_name == "proj_to_kpi_goal") {
                          Formatter = MetricFormatter.Revenue;
                        }

                        return metric.programmatic_name.includes("or") || metric.programmatic_name.includes("kpi") ? (
                          <td></td>
                        ) : (
                          <td key={metric.programmatic_name} className={className ? className + " text-white" : ""}>
                            <Formatter value={value} />
                          </td>
                        );
                      })}
                    </tr>
                  </tbody>
                </Table>
              </div>
            </PDFPage>
          );
        })}
      </div>
    );
  }
}

export default PPCPdfSummarySearch;
